<!-- 
Explanation for the "incomplete contacts" warning.
-->
<template>
  <div>
    <p>
      {{ text | explanation }}
    </p>
    <p>
      Please follow up with the provider and encourage them to update their contact details in HITS. 
      Once they have done so the updated contacts should appear in LTPS the next day.
    </p>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";

export default {
  mixins: [filterMixins],
  props: {
    text: {
      type: String,
      required: true
    }
  }
};
</script>
